const AVAILABLE_DTYPES = {
  'object': 'text',
  'datetime64[ns]': 'date',
  'int64': 'int',
  'float64': 'float',
  'float to text without decimal': 'float to text without decimal',
};

export const getSearchParam = (key=null) => {
  const params = new window.URLSearchParams(window.location.search);
  if (!key) return params;
  return params.get(key) || null
};

export const getNumericalValue = (value, round=2) => {
  if (value === '0.0 %') {
    return '0 %'
  }
  if (typeof (value) === typeof (1)) {
    if (value === 0) {
      return '-';
    }
    value = value.toFixed(round).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
  }
  if (value === '0') {
    return '-'
  }
  return value;
};

export const translatePandasTypesToHuman = (pandasType) => {
  if (!pandasType) return '';
  if (pandasType.toLowerCase().includes('mm')) return 'Date';
  return AVAILABLE_DTYPES[pandasType.toLowerCase()] || AVAILABLE_DTYPES[pandasType] || pandasType;
};

const dateFormats = [
  'YYYYMMDD',
  'YYYYDDMM',
  'DDMMYYYY',
  'MMDDYYYY',
  'YYYY/MM/DD',
  'YYYY-MM-DD',
  'YYYY/DD/MM',
  'YYYY-DD-MM',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'MM-DD-YYYY',
  'MM/DD/YYYY',
  'MMDD',
];

export const GROUPED_TYPES = {
  'Numeric': {
    'int64': 'Int',
    'float64': 'Float'
  },
  'Text': {
    'object': 'Text',
    'float to text without decimal': 'Float to text without decimal'
  },
  'Date': dateFormats,
};
